import { useMemo, useState } from 'react';
import { getModelSignaturesFromModelVersion } from 'modules/Playground/hooks/utils/useFetchModelOutput/getModelSignaturesFromModelVersion';
import { useLanguageOptionsForModels } from 'modules/EntityReference/CodeSnippets/useLanguageOptionsForModels';
import { ApiModelVersion, ApiModel } from 'types/swagger/clarifai-api';
import { useDeepCompareEffect } from 'react-use';
import { container } from './CodeSnippet.styles';
import { InstallAndAuthenticate } from './InstallAndAuthenticate';
import { RunSnippetSteps } from './RunSnippetSteps';
import { useTrendingModels } from '../hooks/useTrendingModels';

export const CodeSnippetContainer = () => {
  const { trendingModels } = useTrendingModels();
  const modelOptions = useMemo(
    () => trendingModels?.map((model) => ({ model: model.modelData, label: model.title, value: model.title, icon: <model.icon size={20} /> })),
    [trendingModels],
  );
  const [model, setModel] = useState(
    modelOptions?.[0] as unknown as { label: string; value: string; icon: JSX.Element | null; model: CF.API.Models.Model | undefined },
  );
  const method_signatures = getModelSignaturesFromModelVersion(
    model?.model?.model_version as unknown as ApiModelVersion,
    model?.model as unknown as ApiModel,
  );
  useDeepCompareEffect(() => {
    if (!model) {
      setModel(modelOptions?.[0] as unknown as { label: string; value: string; icon: JSX.Element | null; model: CF.API.Models.Model | undefined });
    }
  }, [modelOptions]);
  const { languageOptions, selectedLanguage, setSelectedLanguage } = useLanguageOptionsForModels({
    modelMethodSignatures: method_signatures,
  });
  return (
    <div className={container} style={{ width: '100%' }}>
      <InstallAndAuthenticate languageOptions={languageOptions} language={selectedLanguage} setLanguge={setSelectedLanguage} />
      <RunSnippetSteps model={model} setModel={setModel} modelOptions={modelOptions} language={selectedLanguage} />
    </div>
  );
};
